import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags } from '@fortawesome/pro-solid-svg-icons';

import AddTagOption from './add_tag_option';

export default function TagOption(props) {
  const { data, innerProps, innerRef, label } = props;

  if (data.type === 'addTag') return <AddTagOption {...props} />;

  return (
    <div ref={innerRef} {...innerProps} className="entity" name="tag">
      <FontAwesomeIcon
        className="type-icon"
        icon={faTags}
        pull="left"
        size="lg"
      />
      <strong>{label}</strong>
    </div>
  );
}

TagOption.propTypes = {
  data: PropTypes.shape({
    type: PropTypes.string
  }).isRequired,
  innerProps: PropTypes.object,
  innerRef: PropTypes.object,
  label: PropTypes.string.isRequired
};
